// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9a03996","952":"a8edebb8"}[chunkId] + ".chunk.js";
};